export default __webpack_public_path__ + "static/politicas-09cacb5ed6c20b0b4cc281b621645044.jpg";